import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as salesCatalystActions from '../../../actions/salesCatalystActions';
import SalesCatalystInput from '../../common/SalesCatalystInput';
import SalesCatalystBoxInput from '../../common/SalesCatalystBoxInput';
// import { numberWithCommas } from '../../../util/CommonUtils';
import { getBackGroundColor, getTextColor, formOverlapTitle } from '../../../util/SalesCatalystUtils';
import {
  SALES_CATALYST_TARGET_MARKET,
  SALES_CATALYST_HEADERINFO_REPORT_NAME,
} from '../../../constants';

class SalesCatalystTargetMarketInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      editSubCategory: '',
      editDefaultHeader: '',
      editIndex: 0,
    };
  }
  componentDidMount() {
    if (this.props.loadTargetMarketGarph &&
      _.isEmpty(this.props.dataSelection.targetEntityOverlap)) {
      this.props.getEntityTargetOverlapWeighted();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.loadTargetMarketGarph !== nextProps.loadTargetMarketGarph) {
      if (nextProps.loadTargetMarketGarph) {
        this.props.getEntityTargetOverlapWeighted();
      } else {
        this.props.resetOverlapWeighted();
      }
    }
  }

  deleteHandler = (field, subCategory) => {
    this.props.deleteSalasCatalystSelection(field, subCategory, SALES_CATALYST_TARGET_MARKET);
  }


  toggleEditMode = (editSubCategory, editIndex, editDefaultHeader, editMode) => {
    this.setState({
      editSubCategory,
      editIndex,
      editMode,
      editDefaultHeader,
    });
  }

  render() {
    const { dataSelection, loadTargetMarketGarph, className,
      children, hideOverlapBox } = this.props;

    let targetEntityOverlap;
    if (!_.isEmpty(dataSelection.targetEntityOverlap)) {
      targetEntityOverlap = dataSelection.targetEntityOverlap;
    }
    return (
      <div>
        {(!this.state.editMode) ? <div className="row fullWidth sales-catalyst-competition-input">
          <div className={className}>
            <SalesCatalystBoxInput
              defaultHeader={'TARGET MARKET'}
              data={dataSelection.targetMarket[0]}
              deleteHandler={this.deleteHandler}
              subCategory={'targetMarket'}
              field={'dataSelection'}
              index={0}
              backgroundColor={getBackGroundColor(dataSelection.targetMarket[0],
                loadTargetMarketGarph, 'TARGETMARKET', this.props.color)}
              color={getTextColor(dataSelection.targetMarket[0],
                loadTargetMarketGarph)}
              dataOnScreen={loadTargetMarketGarph}
              toggleEditMode={this.toggleEditMode}
            />
          </div>
          {(!hideOverlapBox) && <div className={className}>
            <SalesCatalystBoxInput
              defaultHeader={'OVERLAP'}
              data={formOverlapTitle(targetEntityOverlap, this.props)}
              deleteHandler={this.deleteHandler}
              subCategory={'targetEntityOverlap'}
              field={'dataSelection'}
              index={0}
              backgroundColor={getBackGroundColor(targetEntityOverlap,
                loadTargetMarketGarph, 'ENTITYTARGETOVERLAP')}
              color={getTextColor(targetEntityOverlap,
                loadTargetMarketGarph)}
              dataOnScreen={loadTargetMarketGarph}
              toggleEditMode={this.toggleEditMode}
              showEditButton={false}
              showDeleteButton={false}
            />
          </div>}
          <div className={className}>
            <SalesCatalystBoxInput
              defaultHeader={'ENTITY'}
              data={dataSelection.entity[0]}
              deleteHandler={this.deleteHandler}
              subCategory={'entity'}
              field={'dataSelection'}
              index={0}
              backgroundColor={getBackGroundColor(dataSelection.entity[0],
                loadTargetMarketGarph, 'ENTITY',  this.props.color)}
              color={getTextColor(dataSelection.entity[0],
                loadTargetMarketGarph)}
              dataOnScreen={loadTargetMarketGarph}
              toggleEditMode={this.toggleEditMode}

            />
          </div>
          {(typeof (children) !== 'undefined') &&
          children
        }
        </div> :
          <div className="large-12 medium-12 small-12 columns" style={{ paddingTop: '1%' }}>
            <div className="large-3 medium-3 small-3 columns" style={{ width: '21%' }}>
              <span className="target-market-label">{this.state.editDefaultHeader}:</span>
            </div>
            <div className="large-6 medium-6 small-6 columns target-market-input">
              <SalesCatalystInput
                data={dataSelection[this.state.editSubCategory].length > 0
                  ? dataSelection[this.state.editSubCategory][this.state.editIndex] : []}
                subCategory={this.state.editSubCategory}
                field={'dataSelection'}
                index={this.state.editIndex}
                targetLabelClass={'target-label-field'}
                dataList={dataSelection[this.state.editSubCategory].length > 0
                  ? dataSelection[this.state.editSubCategory] : []}
                toggleEditMode={this.toggleEditMode}
                renderEditView={this.state.editMode}
              />
            </div>
          </div>}
      </div>
    );
  }
}

SalesCatalystTargetMarketInput.defaultProps = {
  className: 'large-4 medium-4 small-4 columns',
  hideOverlapBox: false,
};

SalesCatalystTargetMarketInput.propTypes = {
  dataSelection: PropTypes.arrayOf(PropTypes.object),
  deleteSalasCatalystSelection: PropTypes.func,
  loadTargetMarketGarph: PropTypes.bool,
  getEntityTargetOverlapWeighted: PropTypes.func,
  resetOverlapWeighted: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.element,
  hideOverlapBox: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
    productNo: typeof state.study.salesCatalystStudy !== 'undefined' &&
      typeof state.study.salesCatalystStudy.pn !== 'undefined' ?
      state.study.salesCatalystStudy.pn : 0,
    definitionTree:
      typeof state.definition.definitionTree !== 'undefined' &&
        typeof state.definition.definitionTree.data !== 'undefined'
        ? state.definition.definitionTree.data
        : [],
    dataSelection: state.salesCatalyst.dataSelection,
    loadTargetMarketGarph: state.salesCatalyst.dataOnScreen.targetMarket,
    salesCatalystStudy: state.study.salesCatalystStudy,
  };
}


const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;

  const deleteSalasCatalystSelection = (mainCategory, subCategory, section) => {
    dispatch(salesCatalystActions.deleteSalesCatalystSelection(mainCategory, subCategory, section));
    dispatch(salesCatalystActions.clearAttitudeDemoSectionData());
    dispatch(salesCatalystActions.resetGraphData(subCategory));
  };

  const getEntityTargetOverlapWeighted = () => {
    if (stateProps.dataSelection.targetMarket.length > 0 &&
      stateProps.dataSelection.entity.length > 0) {
      const entityLabel = _.clone(stateProps.dataSelection.entity[0].label);
      const targetMarketLabel = _.clone(stateProps.dataSelection.targetMarket[0].label);
      const overlapLabel = `${targetMarketLabel} AND ${entityLabel}`;
      const productNo = stateProps.salesCatalystStudy.pn;
      const token = stateProps.loginResponse.data.token;
      const uid = stateProps.loginResponse.data.uid;
      const accountId = stateProps.activeAccountId;
      const expression = `(${_.clone(stateProps.dataSelection.targetMarket[0].expression)}) AND (${_.clone(stateProps.dataSelection.entity[0].expression)})`;
      const expressionList = [];
      const personaLabel = [];
      expressionList.push(expression);
      personaLabel.push(overlapLabel);
      const headerInfo = {};
      headerInfo.label = personaLabel;
      headerInfo.expression = expressionList;
      dispatch(salesCatalystActions.getSalesHeaderInfo(
        token,
        uid,
        accountId,
        headerInfo,
        SALES_CATALYST_HEADERINFO_REPORT_NAME,
        productNo,
      ));
    }
  };

  const resetOverlapWeighted = () => {
    dispatch(salesCatalystActions.resetOverlapWeighted());
  };

  return Object.assign({}, stateProps, ownProps, {
    deleteSalasCatalystSelection,
    getEntityTargetOverlapWeighted,
    resetOverlapWeighted,
  });
};

export default connect(
  mapStateToProps,
  null,
  mergeProps,
  { forwardRef: true },
)(SalesCatalystTargetMarketInput);
